(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["engraving-studio"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
  document.querySelectorAll('[data-estudio]').forEach(function (root) {
    var dataEl = root.querySelector('[data-estudio-data]');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var productSel = root.querySelector('[data-estudio-product]');
    var variantField = root.querySelector('[data-estudio-variants]');
    var variantSel = root.querySelector('[data-estudio-variant]');
    var input = root.querySelector('[data-estudio-input]');
    var previews = root.querySelectorAll('[data-estudio-preview]');
    var count = root.querySelector('[data-estudio-count]');
    var priceEl = root.querySelector('[data-estudio-price]');
    var addBtn = root.querySelector('[data-estudio-add]');
    var statusEl = root.querySelector('[data-estudio-status]');
    var max = input.getAttribute('maxlength');
    var fallback = input.getAttribute('placeholder');
    var fmt;
    try { fmt = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }); } catch (e) { fmt = null; }
    function money(c) { return fmt ? fmt.format(c / 100) : (c / 100).toFixed(2) + ' €'; }

    var fontKey = 'serif';
    var fontLabel = root.querySelector('[data-estudio-font]').getAttribute('data-estudio-label');

    function currentProduct() {
      return data.products.filter(function (p) { return String(p.id) === String(productSel.value); })[0];
    }
    function currentVariant() {
      var p = currentProduct();
      if (!p) return null;
      if (p.variants.length > 1) {
        return p.variants.filter(function (v) { return String(v.id) === String(variantSel.value); })[0];
      }
      return p.variants[0];
    }
    function updatePrice() {
      var v = currentVariant();
      if (!v) { priceEl.textContent = ''; return; }
      var total = v.price + data.feePrice;
      priceEl.innerHTML = money(total) + ' <span>(' + money(v.price) + ' + ' + money(data.feePrice) + ' ' + (data.feeWord || 'Gravur') + ')</span>';
    }
    function renderProduct() {
      var p = currentProduct();
      if (!p) return;
      if (p.variants.length > 1) {
        variantSel.innerHTML = p.variants.map(function (v) {
          return '<option value="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' + v.title + ' — ' + money(v.price) + '</option>';
        }).join('');
        variantField.hidden = false;
      } else {
        variantField.hidden = true;
      }
      updatePrice();
    }
    function syncText() {
      var t = input.value.trim();
      count.textContent = input.value.length + '/' + max;
      var label = t || fallback;
      previews.forEach(function (el) { el.textContent = label; });
      if (statusEl && t) statusEl.textContent = '';
    }

    productSel.addEventListener('change', function () { renderProduct(); });
    if (variantSel) variantSel.addEventListener('change', updatePrice);
    input.addEventListener('input', syncText);
    root.querySelectorAll('[data-estudio-font]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        root.querySelectorAll('[data-estudio-font]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
        btn.setAttribute('aria-pressed', 'true');
        fontKey = btn.getAttribute('data-estudio-font');
        fontLabel = btn.getAttribute('data-estudio-label');
        previews.forEach(function (el) { el.className = 'estudio__preview estudio__preview--' + fontKey; });
      });
    });

    addBtn.addEventListener('click', function () {
      var t = input.value.trim();
      var v = currentVariant();
      var p = currentProduct();
      if (!v) return;
      if (!t) {
        input.focus();
        previews.forEach(function (el) { el.classList.add('estudio__preview--flash'); });
        setTimeout(function () { previews.forEach(function (el) { el.classList.remove('estudio__preview--flash'); }); }, 600);
        if (statusEl) statusEl.textContent = data.emptyError || '';
        return;
      }
      addBtn.classList.add('is-loading');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [
          { id: v.id, quantity: 1, properties: { 'Gravur': t, 'Schriftart': fontLabel } },
          { id: data.fee, quantity: 1 }
        ] })
      }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          if (res.ok) {
            var toggle = document.querySelector('[data-cart-toggle]');
            if (toggle) toggle.click(); else window.location = '/cart';
          } else {
            addBtn.classList.add('is-error');
            setTimeout(function () { addBtn.classList.remove('is-error'); }, 1500);
          }
        })
        .finally(function () { addBtn.classList.remove('is-loading'); });
    });

    renderProduct();
    syncText();
  });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initRotator(root) {
    var slides = root.querySelectorAll('.hero__slide');
    var dots = root.querySelectorAll('.hero__dot');
    if (slides.length < 2) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var i = 0, timer = null, delay = 3000;

    function show(n) {
      slides[i].classList.remove('is-active');
      if (dots[i]) { dots[i].classList.remove('is-active'); dots[i].setAttribute('aria-current', 'false'); }
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-active');
      if (dots[i]) { dots[i].classList.add('is-active'); dots[i].setAttribute('aria-current', 'true'); }
    }
    function start() { if (!reduce.matches && !timer) timer = setInterval(function () { show(i + 1); }, delay); }
    function stop() { clearInterval(timer); timer = null; }

    dots.forEach(function (dot, idx) {
      dot.addEventListener('click', function () { stop(); show(idx); start(); });
    });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
    reduce.addEventListener('change', function () { reduce.matches ? stop() : start(); });
    start();
  }
  document.querySelectorAll('[data-hero-rotator]').forEach(initRotator);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
(function () {
  function fade(wrap) {
    var nav = wrap.querySelector('.coll__cats');
    if (!nav) return;
    var max = nav.scrollWidth - nav.clientWidth;
    wrap.classList.toggle('has-left', nav.scrollLeft > 2);
    wrap.classList.toggle('has-right', max > 2 && nav.scrollLeft < max - 2);
  }
  document.querySelectorAll('.coll__cats-wrap[data-cats]').forEach(function (wrap) {
    var nav = wrap.querySelector('.coll__cats');
    if (!nav) return;
    var active = wrap.querySelector('.coll__cat.is-active');
    if (active) {
      var off = active.offsetLeft - 16;
      if (off > 0) nav.scrollLeft = off;
    }
    fade(wrap);
    nav.addEventListener('scroll', function () { fade(wrap); }, { passive: true });
    window.addEventListener('resize', function () { fade(wrap); }, { passive: true });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
(function () {
  document.querySelectorAll('.pdp__gallery[data-gallery]').forEach(function (g) {
    var track = g.querySelector('[data-track]');
    var dots = g.querySelectorAll('.pdp__dot');
    if (track && dots.length) {
      var slides = track.querySelectorAll('.pdp__slide');
      track.addEventListener('scroll', function () {
        var idx = Math.round(track.scrollLeft / track.clientWidth);
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
      }, { passive: true });
      dots.forEach(function (d, i) {
        d.addEventListener('click', function () { slides[i].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' }); });
      });
    }
  });

  // Sticky buy bar (mobile): shown once the shopper has started scrolling and the main
  // add-to-cart button is off-screen, so it never covers the price on the first view.
  var bar = document.querySelector('[data-buybar]');
  var mainAdd = document.querySelector('.pdp__add');
  if (bar && mainAdd && 'IntersectionObserver' in window) {
    var barBtn = bar.querySelector('.pdp__bar-btn');
    var addOffscreen = false;
    function syncBar() {
      var show = addOffscreen && window.scrollY > 80;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (barBtn) barBtn.tabIndex = show ? 0 : -1;
    }
    new IntersectionObserver(function (entries) {
      addOffscreen = !entries[0].isIntersecting;
      syncBar();
    }).observe(mainAdd);
    window.addEventListener('scroll', syncBar, { passive: true });
  }

  document.querySelectorAll('.pdp__form').forEach(function (form) {
    var priceEl = form.parentElement.querySelector('[data-price]');
    var barPrice = document.querySelector('[data-bar-price]');
    var qty = form.querySelector('.pdp__qty-in');
    var incBtn = form.querySelector('.pdp__step[data-step="1"]');

    // Cap quantity at the in-stock ceiling — set per variant as the input's `max` from
    // Liquid. No count is shown; the shopper just can't exceed stock and the "+" disables
    // at the ceiling. Shopify's checkout stays the authoritative backstop.
    function ceiling() {
      var m = qty ? parseInt(qty.getAttribute('max'), 10) : NaN;
      return (isNaN(m) || m < 1) ? Infinity : m;
    }
    function clampQty() {
      if (!qty) return;
      var v = parseInt(qty.value, 10) || 1;
      var max = ceiling();
      if (v < 1) v = 1;
      if (v > max) v = max;
      qty.value = v;
      if (incBtn) incBtn.disabled = (v >= max);
    }

    form.querySelectorAll('.pdp__pill-in').forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (priceEl && radio.dataset.price) priceEl.textContent = radio.dataset.price;
        if (barPrice && radio.dataset.price) barPrice.textContent = radio.dataset.price;
        if (qty) {
          if (radio.dataset.max) qty.setAttribute('max', radio.dataset.max);
          else qty.removeAttribute('max');
          clampQty();
        }
      });
    });

    form.querySelectorAll('.pdp__step').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!qty) return;
        qty.value = (parseInt(qty.value, 10) || 1) + parseInt(btn.dataset.step, 10);
        clampQty();
      });
    });
    if (qty) qty.addEventListener('input', clampQty);
    clampQty();
  });

  // Engraving is wired via delegation on document so it works regardless of when
  // the section JS runs and survives theme-editor section re-renders.
  function engraveSync(root) {
    var input = root.querySelector('[data-engrave-input]');
    if (!input) return;
    var preview = root.querySelector('[data-engrave-preview]');
    var count = root.querySelector('[data-engrave-count]');
    var fontVal = root.querySelector('[data-engrave-font-value]');
    var t = input.value.trim();
    if (count) count.textContent = input.value.length + '/' + input.getAttribute('maxlength');
    if (preview) preview.textContent = t || input.getAttribute('placeholder');
    // Only attach the "Schriftart" property when an engraving was actually entered.
    if (fontVal) fontVal.disabled = (t === '');
  }

  document.addEventListener('input', function (e) {
    var input = e.target.closest && e.target.closest('[data-engrave-input]');
    if (!input) return;
    var root = input.closest('[data-engrave]');
    if (root) engraveSync(root);
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-engrave-font]');
    if (!btn) return;
    var root = btn.closest('[data-engrave]');
    if (!root) return;
    root.querySelectorAll('[data-engrave-font]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
    btn.setAttribute('aria-pressed', 'true');
    var preview = root.querySelector('[data-engrave-preview]');
    var fontVal = root.querySelector('[data-engrave-font-value]');
    if (preview) preview.className = 'pdp__engrave-preview pdp__engrave-preview--' + btn.getAttribute('data-engrave-font');
    if (fontVal) fontVal.value = btn.getAttribute('data-engrave-label');
  });

  // Capture phase so this runs before cart.js's bubble-phase submit handler and can
  // bundle the product + flat fee. Empty engraving falls through to the normal add.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('.pdp__form')) return;
    var root = form.querySelector('[data-engrave]');
    if (!root) return;
    var input = root.querySelector('[data-engrave-input]');
    var t = input ? input.value.trim() : '';
    var feeId = root.getAttribute('data-engrave-fee');
    if (!t || !feeId) return;
    e.preventDefault();
    e.stopPropagation();
    var idEl = form.querySelector('[name="id"]:checked') || form.querySelector('[name="id"]');
    var variantId = idEl ? idEl.value : null;
    if (!variantId) return;
    var qtyEl = form.querySelector('[name="quantity"]');
    var quantity = qtyEl ? (parseInt(qtyEl.value, 10) || 1) : 1;
    var fontVal = root.querySelector('[data-engrave-font-value]');
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.classList.add('is-loading');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [
        { id: variantId, quantity: quantity, properties: { 'Gravur': t, 'Schriftart': fontVal ? fontVal.value : '' } },
        { id: feeId, quantity: quantity }
      ] })
    }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (res.ok) {
          var toggle = document.querySelector('[data-cart-toggle]');
          if (toggle) toggle.click(); else window.location = '/cart';
        } else if (btn) {
          btn.classList.add('is-error');
          setTimeout(function () { btn.classList.remove('is-error'); }, 1500);
        }
      })
      .catch(function () {
        if (btn) { btn.classList.add('is-error'); setTimeout(function () { btn.classList.remove('is-error'); }, 1500); }
      })
      .finally(function () { if (btn) btn.classList.remove('is-loading'); });
  }, true);

  document.querySelectorAll('[data-engrave]').forEach(engraveSync);
})();

  } catch(e) { console.error(e); }
})();
})();
